import React, { useEffect, useMemo, useState } from "react";

/**Import Styles and Assets */
import styles from "./SoundTracks.module.scss";
import back from "./images/back.svg"

import { useAdminTracksHeader } from "../../schemas/tableHeaderSchema";
import TableLayout from "../../components/TableLayout";
import { useDispatch, useSelector } from "react-redux";
import { createAdminTrackThunk, fetchAdminTrackThunk } from "../../features/AdminTrackReducer";
import FileReaderModal from "../../components/Modal/FileReaderModal";
import { Upload } from "antd";
import { AiOutlinePlus } from "react-icons/ai"
import { BsHeadphones } from "react-icons/bs"
import { Toast } from "../../hooks/useToast";
import _ from "lodash"
import { resetValue } from "../../features/SearchReducer";

export default function AdminTracks() {

    const [isSubmitted, setIsSubmitted] = useState(false);
    const { data, status } = useSelector(state => state.adminTracks);
    const { slug } = useSelector(state => state.profile.data);
    const { search } = useSelector(state => state.search);
    const dispatch = useDispatch();
    const [isListed, setIsListed] = useState(true)

    const filterData = useMemo(() => {
        return data.filter(item => item.track_name.includes(search))
    }, [search, data])

    const [file, setFile] = useState({
        path: "",
        type: ""
    });
    const [details, setDetails] = useState({
        track_name: '',
        track_artist: '',
        file_data: '',
    })

    const header = useAdminTracksHeader(setFile);

    useEffect(() => {
        if (status !== "success") {
            dispatch(fetchAdminTrackThunk());
        }

        return () => dispatch(resetValue());
    }, [])


    function handleClose() {
        setFile({
            path: "",
            type: "",
        })
    }

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setDetails(prev => {
            return {
                ...prev,
                [name]: value
            }
        })
    }


    const beforeUpload = (file) => {
        const isJpgOrPng = file.type === 'audio/mpeg' || file.type === 'image/png';
        if (!isJpgOrPng) {
            Toast('You can only upload Audio file!', 'error', false);
        }
        return isJpgOrPng;
    };

    const handleFileChange = (info) => {
        setDetails(prev => {
            return {
                ...prev,
                file_data: info.file.originFileObj
            }
        });

    }

    const toBase64 = file => new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = reject;
    });

    const dummyRequest = ({ file, onSuccess }) => {
        setTimeout(() => {
            onSuccess("ok");
        }, 0);
    };

    const handleBackButton = () => {
        if (isSubmitted) return;
        setIsListed(true);
    }

    const handleSubmit = async () => {
        if (isSubmitted) return;

        if (!details?.track_artist || !details?.track_name || !details?.file_data) {
            return Toast('Fields should not be empty', 'error', false);
        }

        setIsSubmitted(true);
        Toast('Uploading Track', 'loading', true);
        const base64 = await toBase64(details.file_data);
        const body = {
            user_slug: slug,
            file_data: base64,
            track_artist: details.track_artist,
            track_name: details.track_name
        }

        dispatch(createAdminTrackThunk({ data: body, setIsListed, setIsSubmitted, setDetails }))

    }



    return isListed ?
        <div className={styles.soundTracks} >
            {file.path ? <FileReaderModal {...{ ...file, handleClose }} /> : ""}
            <div className={styles.headerContainer}>
                <h1 className={styles.contentTitle}>Upload Sound Tracks</h1>
                <button className={styles.add} onClick={() => setIsListed(false)}>Add New</button>
            </div>
            <div className={styles.content}>
                <TableLayout headers={header} data={filterData} status={status} />
            </div>
        </div > :
        <div className={styles.soundTracks} >
            <div onClick={handleBackButton} className={styles.backButton}>
                <img src={back} alt="<" />
                <h1 className={styles.backButton} >Back</h1>
            </div>
            <div className={styles.fieldsContainer}>
                <Upload
                    name="file_data"
                    listType="picture-card"
                    className={`avatar-uploader ${styles.imageContainer}`}
                    showUploadList={false}
                    beforeUpload={beforeUpload}
                    accept=".mp3,audio/mpeg"
                    onChange={handleFileChange}
                    customRequest={dummyRequest}
                >
                    {!_.isEmpty(details.file_data) ?
                        <>
                            <span className={styles.uploadIcon}><BsHeadphones /></span>
                            <h3 className={styles.uploadDescription}>{details.file_data.name}</h3>
                        </> :
                        <>
                            <span className={styles.uploadIcon}><AiOutlinePlus /></span>
                            <h3>Select Track</h3>
                        </>
                    }
                </Upload>
                <div className={styles.updateInput}>
                    <input type="text" name="track_name" value={details.track_name} onChange={handleInputChange} placeholder="Enter Track Name" className={styles.input} />
                </div>
                <div className={styles.updateInput}>
                    <input type="text" name="track_artist" value={details.track_artist} onChange={handleInputChange} placeholder="Enter Track Artist" className={styles.input} />
                </div>

                <button className={styles.submit} onClick={handleSubmit}>
                    Submit
                </button>

            </div>
        </div >





}